import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import MainSectionLayout from "../../layout/MainSectionLayout";
import { encryptData, postOrPutRequest, validateData } from "../../utils/utils";
import { text } from "@fortawesome/fontawesome-svg-core";
import Cookies from "js-cookie";
import FormError from "../../components/FormError"
import ModalRecoveryPassword from "../../Modals/Modals.js"
import { Eye, EyeOff } from "lucide-react";

const LogIn = () => {
	const [formulario, setFormulario] = useState({
		email: '',
		password: '',
	});

	const [alert, setAlert] = useState([{
		inputName: "",
		status: false,
		message: ""
	}]);

	const [view2FA, setView2FA] = useState(false);
	const [factor, setFactor] = useState(null);

	const navigate = useNavigate();


	const sendData = async () => {
		// console.log(formulario)
		// return; // Detiene todo 
		let response = await postOrPutRequest(
			`auth/login`,
			'POST',
			{
				email: encryptData(formulario.email),
				password: encryptData(formulario.password),
				origin: encryptData("app"),
			}
		);
		console.log(response);

		/**Deshabilitar cuando se habilite el proceso de 2FA */
		if (response.type === 'success') {

			Swal.fire({
				title: '¡Bienvenido!',
				text: 'Inicio de sesión exitoso',
				icon: 'success',
				confirmButtonText: 'Aceptar',
				timer: 3000
			}).then(() => {
				if (response.token && !response.token_type && !response.access_token && !response.data) {
					navigate(`/reset/${response.token}`);
					return;
				}

				Cookies.set(process.env.REACT_APP_TOKEN, encryptData(response.access_token), { expires: 1 });
				Cookies.set(process.env.REACT_APP_USER, encryptData(JSON.stringify(response.data)), { expires: 1 });

				if (response.data.type_id === 4 && response.data.company.completed === 0) {
					navigate('/InitForm');
					return;
				}
				navigate('/PanelDeControl');
				return;
			});
		} else {
			Swal.fire({
				title: response.message,
				text: 'Verifique su información',
				icon: 'warning',
				confirmButtonText: 'Aceptar',
			});
		}

		/**Habilitar cuando se habilite el proceso de 2FA */
		// if (response.type === 'success') {
		// 	console.log("Response Success", response);
		// 	//Proceso cuando la persona tiene contraseña temporal
		// 	if (response.token) {
		// 		if (response.type === 'success') {
		// 			Swal.fire({
		// 				title: '¡Bienvenido!',
		// 				text: 'Inicio de sesión exitoso',
		// 				icon: 'success',
		// 				confirmButtonText: 'Aceptar',
		// 				timer: 3000
		// 			}).then(() => {
		// 				if (response.token && !response.token_type && !response.access_token && !response.data) {
		// 					navigate(`/reset/${response.token}`);
		// 					return;
		// 				}

		// 				Cookies.set(process.env.REACT_APP_TOKEN, encryptData(response.access_token), { expires: 1 });
		// 				Cookies.set(process.env.REACT_APP_USER, encryptData(JSON.stringify(response.data)), { expires: 1 });

		// 				if (response.data.type_id === 4 && response.data.company.completed === 0) {
		// 					navigate('/InitForm');
		// 					return;
		// 				}
		// 				navigate('/PanelDeControl');
		// 				return;
		// 			});
		// 		} 
		// 		/**Proceso de incio de sesión normal */
		// 		else {
		// 			Swal.fire({
		// 				title: response.message,
		// 				text: 'Verifique su información',
		// 				icon: 'warning',
		// 				confirmButtonText: 'Aceptar',
		// 			});
		// 		}
		// 	} else {
		// 		setFactor(response.factor_id);
		// 		Swal.fire({
		// 			title: '¡Verificación de inicio de sesión!',
		// 			text: 'Se ha enviado un código de verificación a su correo electrónico.',
		// 			icon: 'success',
		// 			confirmButtonText: 'Aceptar',
		// 			timer: 5000
		// 		});
		// 		setView2FA(true);
		// 	}
		// } else {
		// 	console.log(response);
		// 	if (response.errors) {
		// 		const listErrors = Object.entries(response.errors)
		// 			.map(([campo, mensaje]) => `<li>• ${mensaje}</li>`)
		// 			.join('');
		// 		Swal.fire({
		// 			title: `Verifique su información`,
		// 			html: `<ul style="text-align: left;">${listErrors}</ul>`,
		// 			icon: 'warning',
		// 			confirmButtonText: 'Aceptar',
		// 		});
		// 		return;
		// 	}
		// 	Swal.fire({
		// 		title: response.message,
		// 		text: 'Verifique su información',
		// 		icon: 'warning',
		// 		confirmButtonText: 'Aceptar',
		// 	});
		// }
	};

	const validateDataForm = (e) => {
		e.preventDefault();

		let inputs = Object.entries(formulario).map(([key, value]) => {
			return {
				name: key,
				value: value,
			};
		});

		const datosValidados = validateData(inputs);
		// console.log(datosValidados)
		setAlert(datosValidados);

		let totalValidaciones = datosValidados.filter((input) => input.status !== false).map(() => {
			return false
		});

		if (totalValidaciones.length < 1) {
			Swal.fire({
				title: 'Cargando...',
				text: 'Por favor espere',
				allowOutsideClick: false,
				didOpen: () => {
					Swal.showLoading();
				}
			});
			sendData();
		}
	}

	const [showPassword, setShowPassword] = useState(false);

	return (
		<MainSectionLayout id="LogIn" view2FA={view2FA} setView2FA={setView2FA} factor={factor} >
			<form onSubmit={validateDataForm} id="LogIn" className="overscroll-noe overflow-y-auto">
				<h1 className="block text-sm sm:text-xl font-medium text-stone-700 dark:text-white">Iniciar sesión</h1>
				<p className="mb-4 block font-normal text-xs text-stone-400 dark:text-stone-400">Por favor ingrese sus credenciales</p>
				<div className="mb-2">
					<label className="mb-1 block font-medium text-sm md:text-sm text-slate-700 dark:text-white">
						Correo electrónico
					</label>
					<div className="relative">
						<input
							type="email"
							placeholder="Ingrese su correo electrónico"
							className="w-full text-xs md:text-sm rounded-md border dark:border-stone-400 placeholder-stone-400 border-stroke bg-transparent py-3 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa dark:text-white focus-visible:shadow-none"
							onChange={(e) => setFormulario({ ...formulario, email: e.target.value })}
						/>
						<FormError errors={alert} name={"email"} />
					</div>
				</div>
				<div className="mb-4">
					<label className="mb-1 block font-medium text-sm md:text-sm text-slate-700 dark:text-white">
						Contraseña
					</label>
					<div className="relative">
						<input
							type={showPassword ? "text" : "password"}
							placeholder="Ingrese su contraseña"
							className="w-full text-xs md:text-sm rounded-md border border-stroke dark:border-stone-400 placeholder-stone-400 bg-transparent py-3 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa focus-visible:shadow-none dark:text-white"
							onChange={(e) => setFormulario({ ...formulario, password: e.target.value })}
						/>
						<button
							type="button"
							onClick={() => setShowPassword(!showPassword)}
							className="absolute flex items-center top-0 bottom-0 right-2 md:right-4 mx-auto h-full"
						>
							{showPassword ? <EyeOff className="w-5 h-5 md:w-6 md:h-6 text-gray-400" /> : <Eye className="w-5 h-5 md:w-6 md:h-6 text-gray-400" />}
						</button>
						<FormError errors={alert} name="password" />
					</div>
				</div>

				<div className="mb-1">
					<button
						className="w-full text-sm md:text-sm font-medium cursor-pointer rounded-md border border-Turquesa dark:border-stone-400 placeholder-stone-400 bg-turquesa py-3 px-2 text-white transition hover:bg-opacity-90 capitalize"
						type="submit"
					>
						Iniciar sesión
					</button>
				</div>
				<div className="mt-6 text-center text-sm sm:text-lg">
					<p className="text-sm font-medium cursor-pointer text-slate-700 dark:text-white">
						¿Ha olvidado su contraseña?&nbsp;
						<span onClick={ModalRecoveryPassword} className="text-turquesa text-sm font-medium cursor-pointer">
							Recuperar contraseña
						</span>
					</p>
				</div>
				{/* <div className="mt-2 mb-7 text-center text-sm text-stone-400">
          <br />
        </div> */}
			</form>
		</MainSectionLayout>
	);
}

export default LogIn;

